module.exports = __webpack_public_path__ + "img/storage39.64792685.jpg";